// GERADO POR scripts/build-icons.js — não edite à mão.
// Fonte: handoff/assets/icons/selo-hex.svg

import React, { useId } from 'react';

/** Proporção nativa 24x26. */
export default function IconeSeloHex({ size = 24, color = 'currentColor', strokeWidth, className, title, ...rest }) {
  // id único por instância: sem isto, dois gradientes iguais colidem na mesma página
  const uid = useId().replace(/:/g, '');
  return (
    <svg
      width={size}
      height={size * 1.0833}
      viewBox="0 0 24 26"
      fill="none"
      className={className}
      role={title ? 'img' : 'presentation'}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...rest}
    >
      {title ? <title>{title}</title> : null}
      <defs><linearGradient id={`g-${uid}`} x1="0" y1="0" x2="1" y2="1"><stop offset="0" stopColor="#FFE58A"></stop><stop offset=".45" stopColor="#FBBD04"></stop><stop offset="1" stopColor="#B8860B"></stop></linearGradient></defs><path d="M12 0l12 6.5v13L12 26 0 19.5v-13z" fill={`url(#g-${uid})`}></path><path d="M17 9.5 10.5 16 7 12.5" fill="none" stroke="#fff" strokeWidth="2.6" strokeLinecap="round" strokeLinejoin="round"></path>
    </svg>
  );
}
